import axios from 'axios'
import { exportAxios } from '@/utils/axiosType'

export default {
  // 获取操作日志
  getOperateLog (params = {
    // pageNum: 0,           // [int] 页码
    // pageSize: 0,          // [int] 页面大小
    // userName: '',         // [str option] 账号
    // startDate: '',        // [str option] 开始时间
    // endDate: '',          // [str option] 结束时间
    // taskType: '',         // [str] 模块： analysis 分析，preHandle预处理，render渲染，frameDetail帧详情
  }) {
    return axios.post('/api/rendering/admin/task/operate/getOperateLog', params)
  },
  // 获取注册来源列表
  getRegisterSourceStatistics (params = {
    // pageNum: 0,           // [int] 页码
    // pageSize: 0,          // [int] 页面大小
    // startTime: '',        // [str option] 开始时间
    // endTime: '',          // [str option] 结束时间
  }) {
    return axios.post('/api/rendering/admin/front/user/getRegisterSourceStatistics', params)
  },
  // 获取版权云注册来源列表
  getCopyRightRegisterSourceStatistics (params = {
    // pageNum: 0,           // [int] 页码
    // pageSize: 0,          // [int] 页面大小
    // startTime: '',        // [str option] 开始时间
    // endTime: '',          // [str option] 结束时间
  }) {
    return axios.post('/api/rendering/admin/front/user/getCopyrightSourceStatistics', params)
  },
  // 获取分享链接统计列表
  getShareLinkStatistics (params = {
    // pageNum: 0,           // [int] 页码
    // pageSize: 0,          // [int] 页面大小
    // userId: '',        // [str option] 用户id
    // userName: '',          // [str option] 用户名
  }) {
    return axios.post('/api/rendering/admin/front/user/shareStatistics', params)
  },
  // 获取卡帧监控列表
  getCurrentAbnormalJobs (params = {}) {
    return axios.post('/api/rendering/admin/task/abnormaljob/currentAbnormalJobs', params)
  },
  // 重提卡帧列表
  restartAbnormalJob (params = {}) {
    return axios.post('/api/rendering/admin/task/abnormaljob/restartAbnormalJob', params)
  },
  // 放弃卡帧列表
  abortAbnormalJob (params = {}) {
    return axios.post('/api/rendering/admin/task/abnormaljob/abortAbnormalJob', params)
  },
  // 清除卡帧监控列表
  removeAbnormalJobCache (params = {}) {
    return axios.post('/api/rendering/admin/task/abnormaljob/removeAbnormalJobCache', params)
  },
  // 获取监控任务消息
  getMonitorTaskList (params = {
    pageNum: 0,           // [int] 页码
    pageSize: 50,          // [int] 页面大小
  }) {
    return axios.post('/api/rendering/admin/task/monitor/list', params)
  },
  // 消息接收控制列表
  getMonitorSubscribeControlList () {
    return axios.post('/api/rendering/admin/task/monitorsubscribe/list')
  },
  // 设置订阅消息
  handleSubscribe (params = {
    messageType: 0, // Integer 消息类型
    enable: 0, // Integer 是否选中站内消息，1/是，0/否
    thresholdCount: 0, // Integer 阈值n个任务/帧
    thresholdRate: 0, // BigDecimal 阈值概率n%,最多两位小数
  }) {
    return axios.post('/api/rendering/admin/task/monitorsubscribe/handleSubscribe', params)
  },
  // 删除订阅消息
  deleteMessage (params = {
    ids: [], // Integer[] 记录id
    selectAll: false, // boolean 全部
  }) {
    return axios.post('/api/rendering/admin/task/monitor/delete', params)
  },
  // 标记消息已读
  markMessage (params = {
    ids: [], // Integer[] 记录id
    selectAll: false, // boolean 全部
  }) {
    return axios.post('/api/rendering/admin/task/monitor/markRead', params)
  },
  queryUserAuthRecord (params) {
    return axios.post('/api/rendering/admin/task/operate/queryUserAuthRecord', params)
  },
  // 设置卡帧
  abnormalJobsSetting (params) {
    return axios.post('/api/rendering/admin/task/abnormaljob/abnormalJobsSetting', params)
  },
  // 卡帧设置回显
  getAbnormalJobsSetting (params) {
    return axios.post('/api/rendering/admin/task/abnormaljob/getAbnormalJobsSetting', params)
  },
  // 取消、恢复卡帧
  operateAbnormalJobs (params) {
    return axios.post('/api/rendering/admin/task/abnormaljob/operateAbnormalJobs', params)
  },
  // 获取卡帧操作记录
  getAbnormalJobsOperateRecords (params) {
    return axios.post('/api/rendering/admin/task/abnormaljob/getAbnormalJobsOperateRecords', params)
  },
  // 查找硬件型号
  getHardwareMode (params) {
    return axios.post('/api/rendering/admin/task/hardwareConfig/getHardwareMode', params)
  },
  // 操作记录导出
  exportOperateLog (params) {
    return axios.post('/api/rendering/admin/task/operate/exportOperateLog', params)
  },
  queryAutoChangeMirrorDetail (params) {
    return axios.post('/api/rendering/admin/task/operate/queryAutoChangeMirrorDetail', params)
  },
  // 获取卡帧监控列表
  getStatisticsCardFrame (params = {}) {
    return axios.post('/api/rendering/admin/task/abnormaljob/countAbnormalJob', params)
  },
  querySource(params) {
    return axios.post('/api/rendering/admin/front/user/source/querySource', params)
  },
  updateSource(params) {
    return axios.post('/api/rendering/admin/front/user/source/updateSource', params)
  },
  addSource(params) {
    return axios.post('/api/rendering/admin/front/user/source/addSource', params)
  },
  deleteSource(params) {
    return axios.post('/api/rendering/admin/front/user/source/deleteSource', params)
  },

  // 卡帧统计
  getStuckFrameStatistics(params) {
    return axios.post('/api/rendering/admin/task/abnormaljob/iconStatistics', params)
  },
  exportStuckFrameStatistics(params) {
    return axios.post('/api/rendering/admin/task/abnormaljob/exportIconStatistics', params)
  },
  // 历史卡帧数据
  getHistoryAbnormalJob(params) {
    return axios.post('/api/rendering/admin/task/abnormaljob/historyAbnormalJob', params)
  },
  // 自然来源
  queryNatureSource(params) {
    return axios.post('/api/rendering/admin/front/user/source/queryNatureSource', params)
  },
  updateNatureSource(params) {
    return axios.post('/api/rendering/admin/front/user/source/updateNatureSource', params)
  },
  addNatureSource(params) {
    return axios.post('/api/rendering/admin/front/user/source/addNatureSource', params)
  },
  deleteNatureSource(params) {
    return axios.post('/api/rendering/admin/front/user/source/deleteNatureSource', params)
  },
  exportFriendInvitationTotals(params) {
    return exportAxios('/api/rendering/admin/front/user/exportFriendInvitationTotals', params)
  },
  exportFriendInvitationDetails(params) {
    return exportAxios('/api/rendering/admin/front/user/exportFriendInvitationDetails', params)
  },
  cancelCardFrame(params) {
    return axios.post('/api/rendering/admin/task/abnormaljob/operateAbnormalJobsBatch', params)
  },
  // 根据操作记录类型查询全部操作项
  queryOperationItems(params) {
    return axios.post('/api/rendering/admin/task/operate/getButtonNameByTaskType', params)
  },
}
